import ApiResourceManager from '../ApiResourceManager';

export default class PushNotificationManager extends ApiResourceManager {
  post = (id, data) =>
    this.request({
      method: 'POST',
      url: `/mobile-apps/${id}/send-test-push-notification`,
      data,
    });
}
